import Routes from './routes'
import reducerFunc from './store'

const Reducers = reducerObj => {
  reducerObj.translationsTool = reducerFunc
}

export default Reducers

export { Routes, Reducers }
